// global
import pullAllWith from 'lodash/pullAllWith';
import isEqual from 'lodash/isEqual';
// local
import { toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'PLANNED_VISITS_PROFESSIONAL';

const sort = function (a, b) {
    return new Date(b.arrivalDate) - new Date(a.arrivalDate);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
    const result = data.filter(item => {
        const patientName = item.patient.name ? filterByTerm(item.patient.name, term) : false;
        const professionalName = item.professional.name ? filterByTerm(item.professional.name, term) : false;
        const code = item.code ? filterByTerm(item.code, term) : false;
        return professionalName || patientName || code;
    });
    if (sort) {
        result.sort(sort);
    }
    return result;
};

const initialState = () => ({
    loading: false,
    data: [],
    filter: {
        term: '',
        data: [],
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = state.data;
            const newData = action.payload;
            return {
                ...state,
                loading: false,
                professional: true,
                data: [...data, ...newData ] ,
                filter: {
                    ...state.filter,
                    // data: filterData(data, state.filter.term),
                    data: [...state.data, ...newData ],
                },
            };
        }
        case `${TEMPLATE_NAME}_SEARCH`: {
            const term = action.payload;
            return {
                ...state,
                filter: {
                    ...state.filter,
                    term,
                    data: filterData(state.data, term),
                },
            };
        }
        case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
            const { data, searchTerm } = action.payload;
            return {
                ...state,
                loading: false,
                filter: {
                    ...state.filter,
                    data: searchTerm ? data : state.loadedData,
                },
            };
        }
        case `${TEMPLATE_NAME}_UPDATE`: {
            const updatedRow = action.payload;
            const data = state.data.map(row => (row.id === updatedRow.id ? updatedRow : row));
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_DELETE`: {
            const deletedId = action.payload;
            const data = state.data.filter(data => data.id !== deletedId);
            
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_REPEATED_CREATE`: {
            const newRows = action.payload;
            const data = [...state.data, ...newRows];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_REPEATED_DELETE`: {
            const deletedRows = action.payload;
            let data = state.data;
            
            data = pullAllWith(data, deletedRows, isEqual);

            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_CREATE`: {
            const newRow = action.payload;
            const data = [...state.data, newRow];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;